import {
  intersectionViewportObserver
} from '@Foundation/utilities/intersectionViewportObserver';

export const heroanim = { // eslint-disable-line
  name: 'hero-anim',
  bind: (el) => {

    document.addEventListener('scroll', () => {

      intersectionViewportObserver(el, {
        checkIsVisible: true
      }).then(() => {
        const scroll = window.pageYOffset;
        const content = el.querySelector('.hero__content');
        const media = el.querySelector('.responsive-image__media');
        const value = (scroll / 5000);
        const scale = 1 + value;
        const margin = scroll / 5;
        if (media) {
          media.style.transform = `scale(${scale}) translate3D(0, ${margin}px, 0)`;
          content.style.opacity = 1 - (margin / 100);
          content.style.top = margin + 'px';
        }
      });
    });
  }
};
